const TermsConditions = () => {
  return (
    <div data-testid="terms-conditions-page" className="pt-32 pb-20 bg-white">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">Terms & Conditions</h1>
          <p className="text-[#6E6E6E] mb-8">Last updated: December 2024</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">1. Agreement to Terms</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                By accessing and using the Decors Genius website and services, you agree to be 
                bound by these Terms and Conditions. If you do not agree with any part of these 
                terms, please do not use our services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">2. Services Description</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Decors Genius provides residential home decoration services including but not 
                limited to: living room decoration, accent wall styling, bedroom enhancements, 
                lighting consultation, and seasonal decoration updates. Service scope and pricing 
                are determined on a project-by-project basis.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">3. Consultations and Estimates</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Initial consultations are provided at no charge. Following the consultation, we 
                will provide a written estimate outlining the project scope, materials, and costs. 
                All estimates are valid for 30 days from the date of issue unless otherwise stated.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">4. Pricing and Payment</h2>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>All prices are quoted in US Dollars</li>
                <li>A deposit may be required before project commencement</li>
                <li>Payment terms are specified in the project agreement</li>
                <li>Prices may vary based on project scope and material costs</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">5. Project Changes</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Any changes to the agreed project scope must be discussed and approved in writing. 
                Additional costs resulting from scope changes will be communicated before proceeding.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">6. Intellectual Property</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                All content on this website, including text, images, and designs, is the property 
                of Decors Genius and is protected by copyright laws. You may not reproduce, 
                distribute, or use any content without our written permission.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">7. Limitation of Liability</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Decors Genius shall not be liable for any indirect, incidental, or consequential 
                damages arising from the use of our services. Our liability is limited to the 
                amount paid for the specific services in question.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">8. Governing Law</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                These Terms and Conditions are governed by the laws of the State of New York, 
                United States, without regard to its conflict of law provisions.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">9. Contact Information</h2>
              <p className="text-[#6E6E6E] leading-relaxed">
                For questions regarding these Terms & Conditions, contact us at:<br />
                Email: support@decorsgenius.store<br />
                Phone: +1-888-880-1455
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
